import { render } from "./MainApp.vue?vue&type=template&id=63bed610"
import script from "./MainApp.vue?vue&type=script&lang=js"
export * from "./MainApp.vue?vue&type=script&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=63bed610&lang=scss"

import exportComponent from "/opt/vrc-osc-remote-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__